module.exports = __webpack_public_path__ + "img/symbol_1.1ec0d512.png";